<template>
  <div>
    <div class="idea-to-evaluate col-md-6 col-sm-10">
      <div class="evaluation-lists">
        <div class="evaluation-list"> {{ listsText }}</div>
      </div>

      <div class="idea-title">{{ idea.title }}</div>
    </div>

    <div class="evaluations col-md-6 col-sm-12">
      <div
        @click="evaluateIdea(-1, null)"
        class="icon-evaluate-full rotate"
      ></div>
      <div
        @click="openOptions()"
        class="icon-help icon-options"
        :class="{ 'grey-background': optionsIsOpen }"
      ></div>
      <div @click="evaluateIdea(1, null)" class="icon-evaluate-full"></div>
    </div>

    <div v-if="optionsIsOpen" class="evaluations-options col-md-6 col-sm-12">
      <div
        v-for="(option, key) in optionsList"
        :key="key"
        class="option-item bold"
        @click="chooseExtraOption(option.code)"
      >
        {{ option.text }}
      </div>
    </div>
  </div>
</template>

<script>
import bus from "../bus";
import api from "../api";

import createEvaluations from "../gql/evaluations/createEvaluations.gql";

export default {
  data() {
    return {
      userLists: [],
      optionsIsOpen: false,
      optionsList: [
        {
          text: "😐 I don't know the subject",
          description: "not_know",
          code: 1,
        },
        {
          text: "🥱 Too obvious",
          description: "obvious",
          code: 2,
        },
        {
          text: "🤔 I don't understand",
          description: "not_understand",
          code: 3,
        },
      ],
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.id;
    },
    userListsStore() {
      return this.$store.state.userLists;
    },
    listsText() {
      let listsText = "";
      for (let i = 0; i < this.idea.lists.length; i++) {
        if (this.idea.lists.length == 1) {
          return this.idea.lists[0].title;
        } else {
          if (i == 0) {
            listsText = "in " + this.idea.lists[i].title;
          } else {
            listsText = listsText + ", " + this.idea.lists[i].title;
          }
        }
      }
      return listsText;
    },
  },
  watch: {
    userListsStore: {
      immediate: true,
      handler: function () {
        this.userLists = this.userListsStore;
      },
    },
  },
  methods: {
    evaluateIdea: function (value, extra_option_code) {
      let newEvaluationsList = [
        {
          user_id: this.userId,
          idea_id: this.idea.id,
          value: value,
          extra_option: extra_option_code,
        },
      ];

      const objects = newEvaluationsList;
      this.$apollo
        .mutate({
          mutation: createEvaluations,
          variables: {
            objects,
          },
        })
        .then(() => {
          bus.$emit("idea-evaluated", this.idea.id);
          this.closeOptions();

          api.createEventTracking(
            "idea-evaluated",
            "idea-evaluated",
            this.userId,
            true
          );
        });
    },
    chooseExtraOption(extra_option_code) {
      this.evaluateIdea(0, extra_option_code);
    },
    openOptions: function () {
      if (!this.optionsIsOpen) {
        this.optionsIsOpen = true;
      } else {
        this.closeOptions();
      }
    },
    closeOptions: function () {
      this.optionsIsOpen = false;
    },
  },
  props: {
    idea: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.idea-to-evaluate {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0px 30px;
}

.idea-title {
  padding: 20px;
  background-color: theme.$white-background;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  overflow: overlay;
  max-height: 200px;
  white-space: pre-line;
}

.evaluations {
  width: 65%;
  position: absolute;
  bottom: 15%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  margin: auto;
}

.evaluations div {
  margin: auto;
}

.evaluations-options {
  width: 84%;
  position: absolute;
  bottom: 25%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.icon-evaluate-full {
  cursor: pointer;
  display: inline-block;
  font-size: 24px;
  border-radius: 50px;
  background: theme.$primary-color;
  padding: 20px;
  width: 60px;
  height: 60px;
}

.icon-evaluate-full:hover {
  background: theme.$primary-color-dark;
}

.icon-evaluate-full::before {
  color: theme.$white-background;
}

.rotate {
  transform: rotate(180deg);
}

div.icon-options {
  margin-left: 16px;
  margin-right: 16px;
  cursor: pointer;
  display: inline-block;
  font-size: 24px;
  color: theme.$text-white;
  border-radius: 50px;
  background: theme.$light-grey-background;
  padding: 20px;
  width: 60px;
  height: 60px;
}

.option-item {
  cursor: pointer;
  border-radius: 4px;
  background: theme.$grey-color;
  color: theme.$text-white;
  padding: 8px;
  margin: 0 auto;
  margin-top: 8px;
}

.evaluation-lists {
  margin-bottom: 8px;
}

.evaluation-list {
  display: inline-block;
  font-weight: 400;
  color: theme.$text-secondary-color;
}
</style>